module.exports = __webpack_public_path__ + "img/quick-start-guide.f56cfa7e.svg";